import type { DateTime } from '@ksyos/date-time';

/**
 *
 * @param earlierDate the date to compare with
 * @param laterDate has to be later than 'earlierDate', otherwise minuses are added
 * @returns { Object } an object with days being an integer, months a float
 */

export interface IMonthsAndDaysDifference {
    days: number;
    months: number;
}

export function calculateMonthsAndDaysDifference(earlierDate: DateTime, laterDate: DateTime): IMonthsAndDaysDifference {
    if (laterDate.isBefore(earlierDate)) {
        const { days, months } = calculateMonthsAndDaysDifference(laterDate, earlierDate);

        return { days: -1 * days, months: -1 * months };
    }

    const dayOfFirstDate = earlierDate.date();
    const monthOfFirstDate = earlierDate.month();
    const yearOfFirstDate = earlierDate.year();
    const dayOfSecondDate = laterDate.date();
    const monthOfSecondDate = laterDate.month();
    const yearOfSecondDate = laterDate.year();
    const yearDifference = yearOfSecondDate - yearOfFirstDate;
    const monthDifference =
        dayOfSecondDate >= dayOfFirstDate
            ? yearDifference * 12 + (monthOfSecondDate - monthOfFirstDate)
            : yearDifference * 12 + (monthOfSecondDate - monthOfFirstDate) - 1;
    const dayDifference = laterDate.diff(earlierDate.add(monthDifference, 'months'), 'days');

    // Depending on the month the secondDate is in, the month will have 28, 29, 30 or 31 days.
    // This is ignored for now so an average of the days per month is taken.
    return { days: dayDifference, months: monthDifference + dayDifference / (365.2425 / 12) };
}
